import React from 'react';
import { BsTelephone, BsGeoAlt } from 'react-icons/bs';
import { PiChatCircleDots } from 'react-icons/pi';

import { Button } from '../../../../../packages/ui-components/shadcn/Button';
import { openMavenoidChat } from '../../../../../packages/ui-components/openChatWidget';

export interface DealerAddressProps {
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  phoneNumber?: string;
  isCompanyOwned?: boolean;
  codCallHours?: string;
}

function DealerAddress({
  addressLine1 = '',
  addressLine2 = '',
  addressLine3 = '',
  city = '',
  state = '',
  zip = '',
  country = '',
  phoneNumber = '',
  isCompanyOwned = false,
  codCallHours = '',
}: Readonly<DealerAddressProps>) {
  const formatPhoneNumber = number =>
    `tel:${number
      .replaceAll('(', '')
      .replaceAll(')', '')
      .replaceAll(' ', '')
      .replaceAll('-', '')}`;

  return (
    <div className="flex flex-wrap flex-col-reverse lg:flex-row mt-4 gap-4">
      <div className="flex-1">
        {phoneNumber && (
          <a
            href={formatPhoneNumber(phoneNumber)}
            className="block text-inherit underline hover:no-underline mt-4 md:mt-2"
          >
            <div className="inline-block align-top">
              <BsTelephone
                size={24}
                aria-hidden="true"
                className="flex mr-2 [&>path]:stroke-[0.5px]"
              />
            </div>
            {phoneNumber}
          </a>
        )}
        {isCompanyOwned && (
          <>
            <div className="mb-4 ml-[calc(1.5em+0.5rem)] md:mb-2">
              <p>Call us anytime</p>
              <p>{codCallHours}</p>
            </div>
            <Button
              onClick={openMavenoidChat}
              className="p-0 h-auto gap-2.5 text-base font-normal underline hover:bg-primary hover:no-underline"
            >
              <PiChatCircleDots
                size={24}
                aria-hidden="true"
                className="flex [&>path]:stroke-[0.5px]"
              />
              Start a Chat
            </Button>
          </>
        )}
      </div>

      {(addressLine1 || addressLine2 || addressLine3) && (
        <div className="flex-[1_0_0] mt-4 lg:mt-2">
          <div className="inline-block align-top">
            <BsGeoAlt
              size={24}
              aria-hidden="true"
              className="flex mr-2 [&>path]:stroke-[0.5px]"
            />
          </div>
          <div className="inline-block">
            {addressLine1 && <p>{addressLine1}</p>}
            {addressLine2 && <p>{addressLine2}</p>}
            {addressLine3 && <p>{addressLine3}</p>}
            {city && state && (
              <p>
                {city}, {state} {zip}
              </p>
            )}
            <p>
              <a
                href={`https://www.google.com/maps/dir/?api=1&destination=${
                  addressLine1 || ''
                }+${addressLine2 || ''}+${city}+${state}+${zip}+${country}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-inherit underline hover:no-underline"
              >
                Directions
              </a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default DealerAddress;
